import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteConditionParams {
  custom_tag_id: number;
  id: number;
}

/**
 * タグ条件を削除するフック
 */
export default function useDeleteTagCondition() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ custom_tag_id, id }: DeleteConditionParams) => {
      const response = await fetch(`/agent/api/custom_tags/${custom_tag_id}/conditions/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || '条件の削除に失敗しました');
      }

      return response.json();
    },
    onSuccess: (_, variables) => {
      // 条件一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/custom_tags', variables.custom_tag_id, 'conditions'],
      });
    },
  });
}
